/* yoclay-cache-bust 20260904133934 */
(function () {
  function readCarouselVisible(scroller) {
    var raw = getComputedStyle(scroller).getPropertyValue('--yoclay-carousel-visible').trim();
    var parsed = parseFloat(raw);
    if (!isNaN(parsed) && parsed > 0) return parsed;
    return countVisibleItems(scroller);
  }

  function countVisibleItems(scroller) {
    var first = scroller.querySelector(':scope > *');
    if (!first) return 1;

    var styles = getComputedStyle(scroller);
    var gap = parseFloat(styles.columnGap || styles.gap) || 0;
    var itemWidth = first.getBoundingClientRect().width;
    if (!itemWidth) return 1;

    return Math.max(1, Math.floor((scroller.clientWidth + gap + 0.5) / (itemWidth + gap)));
  }

  function getCarouselMetrics(scroller) {
    var styles = getComputedStyle(scroller);
    var gap = parseFloat(styles.columnGap || styles.gap) || 0;
    var first = scroller.querySelector(':scope > *');
    var itemWidth = first ? first.getBoundingClientRect().width : 0;
    var visible = readCarouselVisible(scroller);
    var pageItems = visible % 1 === 0 ? visible : 1;
    var pageWidth = scroller.clientWidth;

    if (visible % 1 === 0) {
      pageWidth = scroller.clientWidth;
    } else if (itemWidth > 0) {
      pageWidth = itemWidth * pageItems + gap * Math.max(0, pageItems - 1);
    }

    return {
      gap: gap,
      itemWidth: itemWidth,
      visible: visible,
      pageItems: pageItems,
      pageWidth: pageWidth
    };
  }

  function getCarouselSnapTargets(scroller, metrics) {
    var maxScroll = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
    if (maxScroll <= 0) return [0];

    var pageWidth = metrics.pageWidth;
    if (!pageWidth || pageWidth <= 0) return [0, maxScroll];

    var targets = [0];
    var pos = pageWidth;
    while (pos < maxScroll - 1) {
      targets.push(pos);
      pos += pageWidth;
    }

    if (targets[targets.length - 1] < maxScroll - 1) {
      targets.push(maxScroll);
    }

    return targets;
  }

  function nearestCarouselSnapTarget(scroller, metrics) {
    var targets = getCarouselSnapTargets(scroller, metrics);
    var scrollLeft = scroller.scrollLeft;
    var nearest = targets[0];
    var minDistance = Math.abs(scrollLeft - nearest);

    for (var i = 1; i < targets.length; i++) {
      var distance = Math.abs(scrollLeft - targets[i]);
      if (distance < minDistance) {
        minDistance = distance;
        nearest = targets[i];
      }
    }

    return nearest;
  }

  function getCarouselSnapIndex(targets, scrollLeft) {
    var index = 0;
    for (var i = 0; i < targets.length; i++) {
      if (targets[i] <= scrollLeft + 2) index = i;
    }
    return index;
  }

  function snapCarouselToPage(scroller, behavior) {
    var metrics = getCarouselMetrics(scroller);
    if (!metrics.pageWidth) return;

    var target = nearestCarouselSnapTarget(scroller, metrics);

    if (Math.abs(target - scroller.scrollLeft) > 1) {
      scroller.scrollTo({ left: target, behavior: behavior || 'smooth' });
    }
  }

  function updateButtons(scroller, prev, next) {
    if (!scroller || !prev || !next) return;

    var totalItems = scroller.querySelectorAll(':scope > *').length;
    var visibleItems = readCarouselVisible(scroller);
    var canScroll = totalItems > visibleItems;
    var overflow = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
    var atStart = scroller.scrollLeft <= 2;
    var atEnd = scroller.scrollLeft >= overflow - 2;

    if (!canScroll) {
      prev.hidden = true;
      next.hidden = true;
      prev.disabled = true;
      next.disabled = true;
      return;
    }

    prev.hidden = atStart;
    next.hidden = atEnd;
    prev.disabled = atStart;
    next.disabled = atEnd;
  }

  function setupCarousel(shell) {
    if (!shell || shell.dataset.yoclayCarouselReady === 'true') return;
    shell.dataset.yoclayCarouselReady = 'true';

    var scroller = shell.querySelector('[data-yoclay-carousel]');
    var prev = shell.querySelector('[data-yoclay-carousel-prev]');
    var next = shell.querySelector('[data-yoclay-carousel-next]');
    if (!scroller || !prev || !next) return;

    function refreshButtons() {
      updateButtons(scroller, prev, next);
    }

    function scrollByPage(direction) {
      var metrics = getCarouselMetrics(scroller);
      var targets = getCarouselSnapTargets(scroller, metrics);
      var currentIndex = getCarouselSnapIndex(targets, scroller.scrollLeft);
      var nextIndex = Math.min(Math.max(0, currentIndex + direction), targets.length - 1);

      scroller.scrollTo({ left: targets[nextIndex], behavior: 'smooth' });
    }

    var snapTimer = null;
    function scheduleSnap() {
      if (snapTimer) window.clearTimeout(snapTimer);
      snapTimer = window.setTimeout(function () {
        if (readCarouselVisible(scroller) % 1 === 0) {
          snapCarouselToPage(scroller, 'smooth');
        }
      }, 120);
    }

    function onScrollerScroll() {
      refreshButtons();
      if (!('onscrollend' in window)) scheduleSnap();
    }

    prev.addEventListener('click', function () { scrollByPage(-1); });
    next.addEventListener('click', function () { scrollByPage(1); });
    scroller.addEventListener('scroll', onScrollerScroll, { passive: true });
    if ('onscrollend' in window) {
      scroller.addEventListener('scrollend', function () {
        if (readCarouselVisible(scroller) % 1 === 0) {
          snapCarouselToPage(scroller, 'smooth');
        }
      }, { passive: true });
    }
    window.addEventListener('resize', refreshButtons);

    scroller.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) {
        img.addEventListener('load', refreshButtons, { once: true });
      }
    });

    if (typeof ResizeObserver !== 'undefined') {
      var observer = new ResizeObserver(refreshButtons);
      observer.observe(scroller);
    }

    refreshButtons();
    window.setTimeout(refreshButtons, 120);
    window.setTimeout(refreshButtons, 480);
  }

  function setupHeroCarousel(root) {
    if (!root || root.dataset.yoclayHeroReady === 'true') return;
    root.dataset.yoclayHeroReady = 'true';

    var track = root.querySelector('[data-yoclay-hero-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-yoclay-hero-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-yoclay-hero-dot]'));
    var prev = root.querySelector('[data-yoclay-hero-prev]');
    var next = root.querySelector('[data-yoclay-hero-next]');
    var currentIndex = 0;
    var timer = null;
    var scrollTimer = null;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function setHeroNavVisibility() {
      var atStart = currentIndex <= 0;
      var atEnd = currentIndex >= slides.length - 1;

      if (slides.length <= 1) {
        if (prev) prev.hidden = true;
        if (next) next.hidden = true;
        return;
      }

      if (prev) {
        prev.hidden = atStart;
        prev.disabled = atStart;
      }
      if (next) {
        next.hidden = atEnd;
        next.disabled = atEnd;
      }
    }

    if (!track || slides.length <= 1) {
      setHeroNavVisibility();
      return;
    }

    function updateActive(index) {
      currentIndex = (index + slides.length) % slides.length;
      dots.forEach(function (dot, dotIndex) {
        var isActive = dotIndex === currentIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    function setActive(index, behavior) {
      updateActive(index);
      track.scrollTo({
        left: slides[currentIndex].offsetLeft,
        behavior: behavior || 'smooth'
      });
      setHeroNavVisibility();
    }

    function nearestSlideIndex() {
      var scrollLeft = track.scrollLeft;
      var nearest = 0;
      var distance = Infinity;

      slides.forEach(function (slide, index) {
        var diff = Math.abs(slide.offsetLeft - scrollLeft);
        if (diff < distance) {
          distance = diff;
          nearest = index;
        }
      });

      return nearest;
    }

    function restartAutoplay() {
      if (timer) window.clearInterval(timer);
      if (root.dataset.autoplay !== 'true' || reduceMotion) return;

      var interval = parseInt(root.dataset.interval, 10) || 5000;
      timer = window.setInterval(function () {
        setActive(currentIndex + 1);
      }, interval);
    }

    if (prev) {
      prev.addEventListener('click', function () {
        setActive(currentIndex - 1);
        restartAutoplay();
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        setActive(currentIndex + 1);
        restartAutoplay();
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        setActive(parseInt(dot.getAttribute('data-yoclay-hero-dot'), 10) || 0);
        restartAutoplay();
      });
    });

    track.addEventListener('scroll', function () {
      if (scrollTimer) window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(function () {
        updateActive(nearestSlideIndex());
        setHeroNavVisibility();
      }, 80);
    }, { passive: true });

    root.addEventListener('mouseenter', function () {
      if (timer) window.clearInterval(timer);
    });
    root.addEventListener('mouseleave', restartAutoplay);
    root.addEventListener('focusin', function () {
      if (timer) window.clearInterval(timer);
    });
    root.addEventListener('focusout', restartAutoplay);

    setActive(0, 'auto');
    restartAutoplay();
  }

  function setupTabs(root) {
    var tabs = root.querySelectorAll('[data-yoclay-tab]');
    var panels = root.querySelectorAll('[data-yoclay-tab-panel]');
    if (!tabs.length || !panels.length) return;

    function activate(tabName) {
      tabs.forEach(function (tab) {
        tab.classList.toggle('is-active', tab.getAttribute('data-yoclay-tab') === tabName);
      });
      panels.forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-yoclay-tab-panel') !== tabName;
      });
      root.querySelectorAll('.yoclay-carousel-shell').forEach(function (shell) {
        var scroller = shell.querySelector('[data-yoclay-carousel]');
        var prev = shell.querySelector('[data-yoclay-carousel-prev]');
        var next = shell.querySelector('[data-yoclay-carousel-next]');
        if (scroller) scroller.scrollLeft = 0;
        if (scroller && prev && next) updateButtons(scroller, prev, next);
        setupCarousel(shell);
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab.getAttribute('data-yoclay-tab'));
      });
    });
    activate('products');
  }

  function setupMobileSubmenus(root) {
    root.querySelectorAll('.mobile-site-nav__icon[aria-expanded]').forEach(function (button) {
      if (button.dataset.yoclaySubmenuReady === 'true') return;
      button.dataset.yoclaySubmenuReady = 'true';
      button.addEventListener('click', function () {
        window.setTimeout(function () {
          button.setAttribute('aria-expanded', button.classList.contains('submenu-open') ? 'true' : 'false');
        }, 0);
      });
    });
  }

  function setMobileDrawerOpen(open) {
    document.querySelectorAll('.header-navigation').forEach(function (drawer) {
      drawer.classList.toggle('header-navigation--open', open);
    });

    document.body.classList.toggle('mobile-menu-open', open);

    document.querySelectorAll('.js-mobile-menu-icon[aria-expanded]').forEach(function (button) {
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function setupMobileDrawer(root) {
    document.querySelectorAll('.js-mobile-menu-icon').forEach(function (button) {
      if (button.dataset.yoclayDrawerButtonReady === 'true') return;
      button.dataset.yoclayDrawerButtonReady = 'true';
      button.setAttribute('aria-expanded', button.setAttribute ? (button.getAttribute('aria-expanded') || 'false') : 'false');

      button.addEventListener('click', function () {
        window.setTimeout(function () {
          setMobileDrawerOpen(true);
        }, 0);
      });
    });

    document.querySelectorAll('.js-close-mobile-menu').forEach(function (button) {
      if (button.dataset.yoclayDrawerCloseReady === 'true') return;
      button.dataset.yoclayDrawerCloseReady = 'true';

      button.addEventListener('click', function () {
        setMobileDrawerOpen(false);
      });
    });

    document.querySelectorAll('.header-navigation').forEach(function (drawer) {
      if (drawer.dataset.yoclayDrawerOverlayReady === 'true') return;
      drawer.dataset.yoclayDrawerOverlayReady = 'true';

      drawer.addEventListener('click', function (event) {
        if (event.target === drawer) {
          setMobileDrawerOpen(false);
        }
      });
    });

    root.querySelectorAll('[data-yoclay-mobile-drawer-toggle]').forEach(function (button) {
      if (button.dataset.yoclayDrawerToggleReady === 'true') return;
      button.dataset.yoclayDrawerToggleReady = 'true';

      button.addEventListener('click', function () {
        var panelId = button.getAttribute('aria-controls');
        var panel = panelId ? document.getElementById(panelId) : null;
        var group = button.closest('.yoclay-mobile-drawer__group');
        var shouldOpen = button.getAttribute('aria-expanded') !== 'true';

        button.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
        if (panel) panel.hidden = !shouldOpen;
        if (group) group.classList.toggle('is-open', shouldOpen);
      });
    });

    if (!window.yoclayMobileDrawerKeyboardReady) {
      window.yoclayMobileDrawerKeyboardReady = true;
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') setMobileDrawerOpen(false);
      });
    }
  }

  function setupProductMenuAccordions(root) {
    root.querySelectorAll('.yoclay-product-menu__list').forEach(function (list) {
      if (list.dataset.yoclayAccordionReady === 'true') return;
      list.dataset.yoclayAccordionReady = 'true';

      var groups = [];
      var currentGroup = null;

      Array.prototype.forEach.call(list.children, function (item) {
        if (item.classList.contains('yoclay-product-menu__item')) {
          currentGroup = {
            item: item,
            trigger: item.querySelector('.yoclay-product-menu__link'),
            panels: []
          };
          groups.push(currentGroup);
          return;
        }

        if (
          currentGroup &&
          item.classList.contains('yoclay-product-menu__subitem') &&
          !item.classList.contains('yoclay-product-menu__subitem--standalone')
        ) {
          currentGroup.panels.push(item);
          item.setAttribute('aria-hidden', 'true');
          return;
        }

        currentGroup = null;
      });

      function setOpen(group, open) {
        group.item.classList.toggle('yoclay-product-menu__item--open', open);
        if (group.trigger) group.trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        group.panels.forEach(function (panel) {
          panel.classList.toggle('yoclay-product-menu__subitem--open', open);
          panel.setAttribute('aria-hidden', open ? 'false' : 'true');
        });
      }

      groups.forEach(function (group) {
        if (!group.trigger || !group.panels.length) return;

        group.item.classList.add('yoclay-product-menu__item--accordion');
        group.trigger.setAttribute('aria-expanded', 'false');

        group.trigger.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();

          var willOpen = !group.item.classList.contains('yoclay-product-menu__item--open');
          groups.forEach(function (otherGroup) {
            if (otherGroup.panels.length) setOpen(otherGroup, false);
          });
          setOpen(group, willOpen);
        });
      });

      var firstGroupWithPanels = groups.find(function (group) {
        return group.trigger && group.panels.length;
      });
      if (firstGroupWithPanels) setOpen(firstGroupWithPanels, true);
    });
  }

  function updateStickyHeaderState() {
    var headerGroup = document.querySelector('.header-group');
    if (!headerGroup) return;

    headerGroup.classList.toggle('yoclay-header--stuck', window.scrollY > 8);
    document.documentElement.style.setProperty('--theme-sticky-header-height', headerGroup.offsetHeight + 'px');
  }

  function setupStickyHeader() {
    if (window.yoclayStickyHeaderReady) {
      updateStickyHeaderState();
      return;
    }

    window.yoclayStickyHeaderReady = true;
    var ticking = false;

    function requestUpdate() {
      if (ticking) return;
      ticking = true;

      window.requestAnimationFrame(function () {
        updateStickyHeaderState();
        ticking = false;
      });
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    updateStickyHeaderState();
  }

  function normalizeInstagramPosts(payload) {
    if (Array.isArray(payload)) return payload;
    if (!payload || typeof payload !== 'object') return [];
    if (Array.isArray(payload.data)) return payload.data;
    if (Array.isArray(payload.posts)) return payload.posts;
    if (payload.media && Array.isArray(payload.media.data)) return payload.media.data;
    if (Array.isArray(payload.media)) return payload.media;
    return [];
  }

  function getInstagramImage(post) {
    if (!post || typeof post !== 'object') return '';

    if (post.media_type === 'VIDEO') {
      return post.thumbnail_url || post.media_url || '';
    }

    if (post.media_type === 'CAROUSEL_ALBUM' && post.children && post.children.data && post.children.data.length) {
      var child = post.children.data[0];
      return child.media_url || child.thumbnail_url || '';
    }

    return post.media_url || post.thumbnail_url || post.image_url || post.image || post.url || '';
  }

  function isInstagramVideo(post) {
    return post && (post.media_type === 'VIDEO' || post.media_type === 'REELS');
  }

  function sortInstagramPosts(posts) {
    return posts.slice().sort(function (a, b) {
      var aTime = Date.parse(a.timestamp || a.created_time || 0) || 0;
      var bTime = Date.parse(b.timestamp || b.created_time || 0) || 0;
      return bTime - aTime;
    });
  }

  function buildInstagramGrid(grid, posts, options) {
    var limit = options.limit;
    var profile = options.profile;
    var iconMarkup = options.iconMarkup;

    var filtered = sortInstagramPosts(posts).filter(function (post) {
      return !!getInstagramImage(post);
    }).slice(0, limit);

    if (!filtered.length) return false;

    var fragment = document.createDocumentFragment();

    filtered.forEach(function (post, index) {
      var imageUrl = getInstagramImage(post);
      var link = post.permalink || post.link || post.permalink_url || profile;
      var caption = post.caption || post.alt || post.alt_text || 'Instagram YoClay';
      var isVideo = isInstagramVideo(post);

      var focusMap = ['50% 42%', '50% 28%', '50% 50%', '50% 38%', '50% 32%'];
      var item = document.createElement('a');
      item.className = 'yoclay-studio__item' + (index === 0 ? ' yoclay-studio__item--featured' : '') + (isVideo ? ' yoclay-studio__item--video' : '');
      item.style.setProperty('--yoclay-studio-focus', focusMap[index] || '50% 50%');
      item.setAttribute('data-yoclay-scroll-reveal', 'pending');
      item.setAttribute('data-yoclay-reveal-delay', String(index * 70));
      item.href = link;
      item.target = '_blank';
      item.rel = 'noopener';
      item.setAttribute('data-yoclay-instagram-card', '');

      var img = document.createElement('img');
      img.src = imageUrl;
      img.alt = String(caption).replace(/\s+/g, ' ').trim().slice(0, 180);
      img.width = index === 0 ? 592 : 288;
      img.height = index === 0 ? 600 : 292;
      img.loading = index === 0 ? 'eager' : 'lazy';
      img.decoding = 'async';
      img.referrerPolicy = 'no-referrer';
      item.appendChild(img);

      if (isVideo) {
        var play = document.createElement('span');
        play.className = 'yoclay-studio__item-play';
        play.setAttribute('aria-hidden', 'true');
        play.innerHTML = '<svg viewBox="0 0 24 24" role="presentation" focusable="false"><path d="M8 5v14l11-7z" fill="currentColor"/></svg>';
        item.appendChild(play);
      }

      if (iconMarkup) {
        var badge = document.createElement('span');
        badge.className = 'yoclay-studio__item-icon';
        badge.setAttribute('aria-hidden', 'true');
        badge.innerHTML = iconMarkup;
        item.appendChild(badge);
      }

      fragment.appendChild(item);
    });

    grid.replaceChildren(fragment);
    return true;
  }

  function parseInstagramUrlList(raw) {
    if (!raw) return [];
    return raw.split('|').map(function (url) {
      return url.trim();
    }).filter(Boolean);
  }

  function resolveInstagramUserId(token, userId) {
    if (userId) return Promise.resolve(userId);

    return fetch('https://graph.instagram.com/me?fields=id&access_token=' + encodeURIComponent(token), {
      credentials: 'omit',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      return response.json().then(function (payload) {
        if (!response.ok || payload.error || !payload.id) {
          throw new Error('Instagram user id unavailable');
        }
        return payload.id;
      });
    });
  }

  function fetchInstagramGraphMedia(token, userId, limit) {
    var fields = [
      'id',
      'caption',
      'media_type',
      'media_url',
      'thumbnail_url',
      'permalink',
      'timestamp',
      'children{media_type,media_url,thumbnail_url}'
    ].join(',');

    var graphUrls = [];

    if (userId) {
      graphUrls.push(
        'https://graph.facebook.com/v21.0/' + encodeURIComponent(userId) + '/media?fields=' + encodeURIComponent(fields) + '&limit=' + limit
      );
    }

    graphUrls.push(
      'https://graph.instagram.com/me/media?fields=' + encodeURIComponent(fields) + '&limit=' + limit
    );

    function tryNext(index) {
      if (index >= graphUrls.length) {
        return Promise.reject(new Error('Instagram Graph API unavailable'));
      }

      var url = graphUrls[index] + '&access_token=' + encodeURIComponent(token);

      return fetch(url, {
        credentials: 'omit',
        headers: { Accept: 'application/json' }
      }).then(function (response) {
        return response.json().then(function (payload) {
          if (!response.ok || payload.error) {
            throw new Error((payload.error && payload.error.message) || 'Instagram Graph API request failed');
          }
          return payload;
        });
      }).catch(function () {
        return tryNext(index + 1);
      });
    }

    return tryNext(0);
  }

  function fetchInstagramBusinessDiscovery(token, userId, username, limit) {
    var fields =
      'business_discovery.username(' +
      username +
      '){media.limit(' +
      limit +
      '){id,caption,media_type,media_url,thumbnail_url,permalink,timestamp}}';

    return fetch(
      'https://graph.facebook.com/v21.0/' +
        encodeURIComponent(userId) +
        '?fields=' +
        encodeURIComponent(fields) +
        '&access_token=' +
        encodeURIComponent(token),
      { credentials: 'omit', headers: { Accept: 'application/json' } }
    ).then(function (response) {
      return response.json().then(function (payload) {
        if (!response.ok || payload.error) {
          throw new Error((payload.error && payload.error.message) || 'Instagram business discovery failed');
        }
        var discovery = payload.business_discovery || {};
        return discovery.media && discovery.media.data ? discovery.media.data : [];
      });
    });
  }

  function fetchInstagramPostsFromOembed(token, urls, limit) {
    var selected = urls.slice(0, limit);

    return Promise.all(
      selected.map(function (postUrl) {
        return fetch(
          'https://graph.facebook.com/v21.0/instagram_oembed?url=' +
            encodeURIComponent(postUrl) +
            '&fields=thumbnail_url,title,author_name&access_token=' +
            encodeURIComponent(token),
          { credentials: 'omit', headers: { Accept: 'application/json' } }
        )
          .then(function (response) {
            return response.json().then(function (payload) {
              if (!response.ok || payload.error || !payload.thumbnail_url) {
                throw new Error('Instagram oEmbed failed');
              }

              return {
                permalink: postUrl,
                thumbnail_url: payload.thumbnail_url,
                media_type: postUrl.indexOf('/reel/') !== -1 ? 'VIDEO' : 'IMAGE',
                caption: payload.title || payload.author_name || 'Instagram YoClay'
              };
            });
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (posts) {
      return posts.filter(Boolean);
    });
  }

  function loadInstagramPostsFromToken(token, userId, username, limit, fallbackUrls) {
    return fetchInstagramGraphMedia(token, userId, Math.max(limit, 5))
      .then(function (payload) {
        var posts = normalizeInstagramPosts(payload);
        if (posts.length) return posts;
        throw new Error('Empty Instagram media list');
      })
      .catch(function () {
        return resolveInstagramUserId(token, userId).then(function (resolvedId) {
          return fetchInstagramBusinessDiscovery(token, resolvedId, username, limit);
        });
      })
      .catch(function () {
        if (!fallbackUrls.length) throw new Error('No fallback Instagram URLs');
        return fetchInstagramPostsFromOembed(token, fallbackUrls, limit);
      });
  }

  function setupInstagramFeed(root) {
    if (!root || root.dataset.yoclayInstagramReady === 'true') return;
    root.dataset.yoclayInstagramReady = 'true';

    var grid = root.querySelector('[data-yoclay-instagram-grid]');
    if (!grid || typeof window.fetch !== 'function') return;

    var endpoint = (root.getAttribute('data-instagram-endpoint') || '').trim();
    var token = (root.getAttribute('data-instagram-token') || '').trim();
    var userId = (root.getAttribute('data-instagram-user-id') || '').trim();
    var limit = parseInt(root.getAttribute('data-instagram-limit'), 10) || 5;
    var profile = root.getAttribute('data-instagram-profile') || 'https://www.instagram.com/yoclay.oficial/';
    var username = (root.getAttribute('data-instagram-username') || 'yoclay.oficial').replace('@', '');
    var fallbackUrls = parseInstagramUrlList(root.getAttribute('data-instagram-urls') || '');
    var icon = grid.querySelector('.yoclay-studio__item-icon');
    var iconMarkup = icon ? icon.innerHTML : '';
    var renderOptions = { limit: limit, profile: profile, iconMarkup: iconMarkup };

    if (!endpoint && !token) {
      root.classList.add('yoclay-studio--fallback');
      return;
    }

    root.classList.add('yoclay-studio--loading');

    var request;

    if (endpoint) {
      request = fetch(endpoint, {
        credentials: 'omit',
        headers: { Accept: 'application/json' }
      }).then(function (response) {
        if (!response.ok) throw new Error('Instagram feed request failed');
        return response.json();
      }).then(function (payload) {
        return normalizeInstagramPosts(payload);
      });
    } else {
      request = loadInstagramPostsFromToken(token, userId, username, limit, fallbackUrls);
    }

    request
      .then(function (posts) {
        if (!buildInstagramGrid(grid, posts, renderOptions)) {
          throw new Error('No Instagram media returned');
        }
        root.classList.add('yoclay-studio--loaded');
        root.classList.remove('yoclay-studio--fallback');
        setupScrollReveals(root);
      })
      .catch(function () {
        root.classList.add('yoclay-studio--fallback');
      })
      .then(function () {
        root.classList.remove('yoclay-studio--loading');
      });
  }

  // ---------------------------------------------------------------------------
  // Cart Drawer
  // ---------------------------------------------------------------------------
  var CART_DRAWER_SELECTOR = '[data-yoclay-cart-drawer]';
  var cartFetchInFlight = null;

  function getCartDrawer() {
    return document.querySelector(CART_DRAWER_SELECTOR);
  }

  function formatMoneyBR(cents) {
    var value = (cents / 100).toFixed(2).replace('.', ',');
    return 'R$ ' + value.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function formatMoneyForCart(cents) {
    var drawer = getCartDrawer();
    var format = drawer && drawer.getAttribute('data-money-format');
    var hasShopify = window.Shopify && typeof Shopify.formatMoney === 'function';

    if (format && hasShopify) {
      try { return Shopify.formatMoney(cents, format); } catch (err) { /* fallback */ }
    }
    if (window.theme && window.theme.Shopify && typeof window.theme.Shopify.formatMoney === 'function') {
      try { return window.theme.Shopify.formatMoney(cents, format || (window.theme.moneyFormat || '')); } catch (err) { /* fallback */ }
    }
    return formatMoneyBR(cents);
  }

  function openCartDrawer() {
    var drawer = getCartDrawer();
    if (!drawer) return;
    drawer.removeAttribute('hidden');
    // Force a reflow so the transition runs
    void drawer.offsetWidth;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('yoclay-cart-drawer-open');

    document.querySelectorAll('[data-yoclay-cart-open]').forEach(function (el) {
      el.setAttribute('aria-expanded', 'true');
    });
  }

  function closeCartDrawer() {
    var drawer = getCartDrawer();
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('yoclay-cart-drawer-open');

    document.querySelectorAll('[data-yoclay-cart-open]').forEach(function (el) {
      el.setAttribute('aria-expanded', 'false');
    });

    // Re-add hidden after transition for screen readers
    window.setTimeout(function () {
      var current = getCartDrawer();
      if (current && !current.classList.contains('is-open')) {
        current.setAttribute('hidden', '');
      }
    }, 320);
  }

  function isCartDrawerOpen() {
    var drawer = getCartDrawer();
    return !!(drawer && drawer.classList.contains('is-open'));
  }

  function bumpCartCount() {
    document.querySelectorAll('[data-yoclay-cart-count]').forEach(function (el) {
      el.classList.remove('is-bumped');
      void el.offsetWidth;
      el.classList.add('is-bumped');
    });
  }

  function updateCartCountElements(count) {
    document.querySelectorAll('[data-yoclay-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', !count);
    });
  }

  function refreshCartDrawer() {
    var drawer = getCartDrawer();
    if (!drawer) return Promise.resolve();
    var sectionId = drawer.getAttribute('data-section-id');
    if (!sectionId) return Promise.resolve();

    if (cartFetchInFlight) return cartFetchInFlight;

    cartFetchInFlight = fetch('/?sections=' + encodeURIComponent(sectionId), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        var html = data && data[sectionId];
        if (!html) return;
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector(CART_DRAWER_SELECTOR);
        if (!fresh) return;

        var wasOpen = drawer.classList.contains('is-open');
        // Preserve open state across replacement
        fresh.classList.toggle('is-open', wasOpen);
        if (!wasOpen) fresh.setAttribute('hidden', '');
        else fresh.removeAttribute('hidden');
        fresh.setAttribute('aria-hidden', wasOpen ? 'false' : 'true');

        drawer.replaceWith(fresh);
        setupCartDrawer();
        if (
          window.yoclayPackPricing &&
          typeof window.yoclayPackPricing.ensurePackDiscountOnCartPage === 'function'
        ) {
          window.yoclayPackPricing.ensurePackDiscountOnCartPage();
        }
      })
      .catch(function () { /* silent */ })
      .then(function () { cartFetchInFlight = null; });

    return cartFetchInFlight;
  }

  function refreshCartCountFromCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        if (cart && typeof cart.item_count === 'number') {
          updateCartCountElements(cart.item_count);
        }
        return cart;
      })
      .catch(function () { return null; });
  }

  function changeCartLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        if (cart && typeof cart.item_count === 'number') {
          updateCartCountElements(cart.item_count);
          bumpCartCount();
        }
        return refreshCartDrawer().then(function () { return cart; });
      });
  }

  function setupCartDrawerControls() {
    if (window.yoclayCartDrawerOpenReady) return;
    window.yoclayCartDrawerOpenReady = true;

    // Event delegation: survives theme.js replacing .header-cart after add-to-cart.
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-yoclay-cart-open]');
      if (!trigger) return;
      // Allow modifier-clicks (open in new tab) to fall through
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) return;
      event.preventDefault();
      openCartDrawer();
    });

    document.addEventListener('click', function (event) {
      var checkoutBtn = event.target.closest('[data-yoclay-cart-checkout]');
      if (!checkoutBtn) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) return;
      event.preventDefault();
      closeCartDrawer();
      if (typeof window.yampiClick === 'function') {
        window.yampiClick();
        return;
      }
      window.location.href = checkoutBtn.getAttribute('href') || '/cart';
    });
  }

  function setupCartDrawer() {
    setupCartDrawerControls();

    var drawer = getCartDrawer();
    if (!drawer) return;

    if (drawer.dataset.yoclayCartReady !== 'true') {
      drawer.dataset.yoclayCartReady = 'true';

      drawer.addEventListener('click', function (event) {
        var closeTrigger = event.target.closest('[data-yoclay-cart-close]');
        if (closeTrigger && drawer.contains(closeTrigger)) {
          // Plain links (e.g. "Ver produtos") should still navigate
          if (closeTrigger.tagName === 'A' && closeTrigger.getAttribute('href') && closeTrigger.getAttribute('href') !== '#') {
            closeCartDrawer();
            return;
          }
          event.preventDefault();
          closeCartDrawer();
        }
      });
    }

    drawer.querySelectorAll('[data-yoclay-cart-item]').forEach(function (item) {
      if (item.dataset.yoclayCartItemReady === 'true') return;
      item.dataset.yoclayCartItemReady = 'true';

      var line = parseInt(item.getAttribute('data-line'), 10);
      var qtyEl = item.querySelector('[data-yoclay-cart-qty]');
      var current = qtyEl ? parseInt(String(qtyEl.textContent || '').replace(/\D/g, ''), 10) || 0 : 0;

      function commit(nextQty) {
        if (item.classList.contains('is-removing')) return;
        item.classList.add('is-removing');
        changeCartLine(line, nextQty).catch(function () {
          item.classList.remove('is-removing');
        });
      }

      var dec = item.querySelector('[data-yoclay-cart-decrease]');
      if (dec) {
        dec.addEventListener('click', function (event) {
          event.preventDefault();
          var next = Math.max(0, current - 1);
          commit(next);
        });
      }

      var inc = item.querySelector('[data-yoclay-cart-increase]');
      if (inc) {
        inc.addEventListener('click', function (event) {
          event.preventDefault();
          commit(current + 1);
        });
      }

      var remove = item.querySelector('[data-yoclay-cart-remove]');
      if (remove) {
        remove.addEventListener('click', function (event) {
          event.preventDefault();
          commit(0);
        });
      }
    });
  }

  if (!window.yoclayCartDrawerKeyboardReady) {
    window.yoclayCartDrawerKeyboardReady = true;
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && isCartDrawerOpen()) {
        closeCartDrawer();
      }
    });
  }

  // --- Montagem kits (Pockets) → cart.note + attributes (Yampi / Bling) ---
  var YOCLAY_POCKET_PROP_KEYS = [
    'Pockets escolhidos',
    'Pockets Escolhidos',
    'Montagem YoClay',
    'Montagem pockets'
  ];
  var YOCLAY_MONTAGEM_NOTE_HEADER_LEGACY = '--- Montagem kits YoClay ---';
  var YOCLAY_MONTAGEM_NOTE_POCKETS = 'MONTAGEM POCKETS:';
  var YOCLAY_MONTAGEM_NOTE_KITS = 'MONTAGEM YOCLAY (KITS):';
  var YOCLAY_MONTAGEM_ATTR_POCKETS_UPPER = 'MONTAGEM POCKETS';
  var YOCLAY_MONTAGEM_ATTR_KITS_UPPER = 'MONTAGEM YOCLAY (KITS)';
  /** Chaves antigas removidas do sync — limpas no cart para não duplicar Inf. Adicionais na Yampi */
  var YOCLAY_MONTAGEM_LEGACY_ATTR_KEYS = [
    'Montagem pockets',
    'Montagem YoClay (kits)',
    'Observações',
    'Observacoes',
    'observacoes',
    'Observacao pedido',
    'Observação pedido',
    'OBSERVACAO PEDIDO',
    'OBSERVAÇÕES'
  ];
  var yoclayMontagemSyncTimer = null;
  var yoclayMontagemSyncInFlight = null;

  function yoclayNormalizePocketValue(value) {
    if (!value || typeof value !== 'string') return '';
    return value.trim().replace(/\s+/g, ' ');
  }

  function yoclayGetPocketsFromLineItem(item) {
    if (!item || !item.properties) return '';
    var i;
    var keys = Object.keys(item.properties);
    for (i = 0; i < keys.length; i++) {
      var key = keys[i];
      if (YOCLAY_POCKET_PROP_KEYS.indexOf(key) !== -1) {
        var val = yoclayNormalizePocketValue(item.properties[key]);
        if (val) return val;
      }
      if (/pocket/i.test(key) && !/^_/i.test(key)) {
        val = yoclayNormalizePocketValue(item.properties[key]);
        if (val) return val;
      }
    }
    return '';
  }

  function yoclayExtractLineItemHandle(item) {
    if (!item) return '';
    if (item.handle) return String(item.handle).toLowerCase();
    var url = item.url || '';
    var match = String(url).match(/\/products\/([^/?#]+)/i);
    return match && match[1] ? match[1].toLowerCase() : '';
  }

  function yoclayShortKitTitle(productTitle, handle) {
    var normalizedHandle = handle ? String(handle).toLowerCase() : '';
    if (normalizedHandle && YOCLAY_KIT_HANDLE_TITLES[normalizedHandle]) {
      return YOCLAY_KIT_HANDLE_TITLES[normalizedHandle];
    }
    if (!productTitle) return 'Kit';
    var title = String(productTitle).trim();
    if (/^kit\s/i.test(title) || /^trio\s/i.test(title) || /^super\s*kit/i.test(title)) {
      return title.split(/\s+[—–-]\s+/)[0].trim();
    }
    if (title.indexOf(' - ') !== -1) {
      var parts = title.split(' - ');
      var last = parts[parts.length - 1].trim();
      if (/^kit\s/i.test(last) || /^trio\s/i.test(last)) return last;
      return parts[0].trim();
    }
    return title;
  }

  var YOCLAY_KIT_HANDLES = {
    'kit-presentear': true,
    'trio-exploradores-yoclay': true,
    'kit-salva-tedio': true,
    'pockets-botanicos': true,
    'pockets-pets': true,
    'yoclay-pockets-edicao-limitada-de-natal': true
  };
  var YOCLAY_KIT_HANDLE_TITLES = {
    'kit-presentear': 'Kit Presentear',
    'trio-exploradores-yoclay': 'Trio Exploradores YoClay',
    'kit-salva-tedio': 'Kit Salva Tédio',
    'pockets-botanicos': 'Pockets Botânicos',
    'pockets-pets': 'Pockets Pets',
    'yoclay-pockets-edicao-limitada-de-natal': 'YoClay Pockets de Natal'
  };
  var YOCLAY_LINE_DISPLAY_NAME_PROP = 'Nome no pedido';
  var YOCLAY_LINE_TITLE_MAX = 255;
  /** Chaves usadas por checkout/ERP ao importar título customizado da linha (empírico Yampi/Shopify) */
  var YOCLAY_YAMPI_LINE_TITLE_PROPS = [
    '_product_title',
    'product_title',
    'product_name',
    'Nome do produto',
    'Título do produto'
  ];

  function yoclayClampLineDisplayTitle(title) {
    if (!title || typeof title !== 'string') return title || '';
    var trimmed = title.trim();
    if (trimmed.length <= YOCLAY_LINE_TITLE_MAX) return trimmed;
    return trimmed.slice(0, YOCLAY_LINE_TITLE_MAX - 1) + '…';
  }

  function yoclayBuildKitLineDisplayName(productTitle, pockets, handle) {
    if (!pockets) return '';
    return yoclayClampLineDisplayTitle(yoclayShortKitTitle(productTitle, handle) + ' — ' + pockets);
  }

  function yoclayLinePropertiesToMap(properties) {
    var map = {};
    if (!properties) return map;
    if (Array.isArray(properties)) {
      properties.forEach(function (entry) {
        if (entry && entry.name) map[entry.name] = entry.value != null ? String(entry.value) : '';
      });
      return map;
    }
    if (typeof properties === 'object') {
      Object.keys(properties).forEach(function (key) {
        map[key] = properties[key] != null ? String(properties[key]) : '';
      });
    }
    return map;
  }

  function yoclayLinePropertiesFromMap(map) {
    if (!map) return {};
    return Object.assign({}, map);
  }

  function yoclayBuildLineDisplayPropertiesMap(pockets, displayTitle) {
    var props = {};
    if (pockets) props['Pockets escolhidos'] = pockets;
    if (displayTitle) {
      props[YOCLAY_LINE_DISPLAY_NAME_PROP] = displayTitle;
      YOCLAY_YAMPI_LINE_TITLE_PROPS.forEach(function (key) {
        props[key] = displayTitle;
      });
    }
    return props;
  }

  function yoclayLineDisplayPropertiesComplete(currentProps, pockets, displayTitle) {
    if (!pockets || !displayTitle) return false;
    var map = yoclayLinePropertiesToMap(currentProps);
    if (map['Pockets escolhidos'] !== pockets) return false;
    if (map[YOCLAY_LINE_DISPLAY_NAME_PROP] !== displayTitle) return false;
    return true;
  }

  function yoclayEnsureLineDisplayProperties(item, displayTitle, pockets) {
    if (!item || !displayTitle) return item;
    var props = yoclayLinePropertiesFromMap(
      Object.assign({}, yoclayLinePropertiesToMap(item.properties), yoclayBuildLineDisplayPropertiesMap(pockets, displayTitle))
    );
    return Object.assign({}, item, { properties: props });
  }

  function yoclayIsKitLineItem(item) {
    if (!item) return false;
    if (yoclayGetPocketsFromLineItem(item)) return true;
    var handle = yoclayExtractLineItemHandle(item);
    return handle && YOCLAY_KIT_HANDLES[handle] === true;
  }

  function yoclayGetLineDisplayTitleFromProperties(item) {
    if (!item || !item.properties) return '';
    var map = yoclayLinePropertiesToMap(item.properties);
    var i;
    var val;
    if (map[YOCLAY_LINE_DISPLAY_NAME_PROP]) {
      val = yoclayNormalizePocketValue(map[YOCLAY_LINE_DISPLAY_NAME_PROP]);
      if (val) return val;
    }
    for (i = 0; i < YOCLAY_YAMPI_LINE_TITLE_PROPS.length; i++) {
      if (map[YOCLAY_YAMPI_LINE_TITLE_PROPS[i]]) {
        val = yoclayNormalizePocketValue(map[YOCLAY_YAMPI_LINE_TITLE_PROPS[i]]);
        if (val) return val;
      }
    }
    var keys = Object.keys(map);
    for (i = 0; i < keys.length; i++) {
      if (/nome no pedido|product_title|product_name/i.test(keys[i])) {
        val = yoclayNormalizePocketValue(map[keys[i]]);
        if (val) return val;
      }
    }
    return '';
  }

  function yoclayLinePropertiesToArray(properties) {
    var map = yoclayLinePropertiesToMap(properties);
    return Object.keys(map).map(function (key) {
      return { name: key, value: map[key] != null ? String(map[key]) : '' };
    });
  }

  /**
 * Payload esperado pelo checkout Yampi (POST api.dooki.com.br/v2/public/shopify/cart):
 * cart_payload.items[].title | product_title | name | product.title — ex.: "Kit Presentear — Tico, Hipo"
 * cart_payload.items[].properties["Nome no pedido"] + _product_title, product_title, …
 * cart_payload.note + attributes MONTAGEM POCKETS / MONTAGEM YOCLAY (KITS)
 * Packs de Pockets: yoclay-pack-pricing.js exibe o desconto visual no carrinho;
 * o desconto real é aplicado pelas regras progressivas na Yampi.
   */
  function yoclayApplyPocketsToLineItemForYampi(item) {
    if (!item || !yoclayIsKitLineItem(item)) return item;
    var pockets = yoclayGetPocketsFromLineItem(item);
    if (!pockets) return item;

    var handle = yoclayExtractLineItemHandle(item);
    var displayTitle = yoclayClampLineDisplayTitle(
      yoclayGetLineDisplayTitleFromProperties(item) ||
        yoclayBuildKitLineDisplayName(item.product_title || item.title, pockets, handle)
    );

    if (!displayTitle) return item;

    var cloned = yoclayEnsureLineDisplayProperties(
      Object.assign({}, item),
      displayTitle,
      pockets
    );
    var titleFields = [
      'title',
      'product_title',
      'name',
      'variant_title',
      'product_name',
      'display_name',
      'line_title',
      'full_title',
      'untranslated_title',
      'untranslated_product_title',
      'sku_title',
      'presentment_title',
      'custom_title',
      'item_title',
      'line_item_title',
      'product_title_custom',
      'checkout_title'
    ];
    titleFields.forEach(function (field) {
      cloned[field] = displayTitle;
    });
    cloned.properties = yoclayLinePropertiesFromMap(
      Object.assign({}, yoclayLinePropertiesToMap(cloned.properties), yoclayBuildLineDisplayPropertiesMap(pockets, displayTitle))
    );
    cloned.properties_array = yoclayLinePropertiesToArray(cloned.properties);
    cloned.line_properties = cloned.properties_array;
    cloned.description = displayTitle;
    cloned.product_description = displayTitle;
    if (item.product && typeof item.product === 'object') {
      cloned.product = Object.assign({}, item.product);
      titleFields.forEach(function (field) {
        if (field in cloned.product || field === 'title' || field === 'product_title' || field === 'name') {
          cloned.product[field] = displayTitle;
        }
      });
      cloned.product.title = displayTitle;
      cloned.product.product_title = displayTitle;
      cloned.product.name = displayTitle;
    } else {
      cloned.product = {
        title: displayTitle,
        product_title: displayTitle,
        name: displayTitle
      };
    }
    return cloned;
  }

  function yoclayMutateCartPayloadForYampi(cart) {
    if (!cart) return cart;
    var next = Object.assign({}, cart);
    if (cart.items && cart.items.length) {
      next.items = cart.items.map(yoclayApplyPocketsToLineItemForYampi);
    }
    if (cart.line_items && cart.line_items.length) {
      next.line_items = cart.line_items.map(yoclayApplyPocketsToLineItemForYampi);
    }
    if (next.items && next.items.length) {
      next.line_items = next.items;
    } else if (next.line_items && next.line_items.length) {
      next.items = next.line_items;
    }
    return next;
  }

  function yoclayMergeYampiCheckoutPayloadOverride(cartPayload) {
    if (!cartPayload) return cartPayload;
    var override = window.yampiCheckoutPayload;
    if (!override || typeof override !== 'object') return cartPayload;
    return Object.assign({}, cartPayload, override);
  }

  window.yoclayMutateCartPayloadForYampi = yoclayMutateCartPayloadForYampi;

  function yoclayWhenFigmaReady() {
    if (typeof window.yoclaySyncPocketMontagemToCart === 'function') {
      return Promise.resolve();
    }
    return new Promise(function (resolve) {
      var attempts = 0;
      var timer = window.setInterval(function () {
        attempts += 1;
        if (typeof window.yoclaySyncPocketMontagemToCart === 'function' || attempts >= 100) {
          window.clearInterval(timer);
          resolve();
        }
      }, 50);
    });
  }

  function yoclayPrepareYampiCartPayload(cartPayload, syncedCart) {
    if (!cartPayload) return cartPayload;
    var prepared;
    if (syncedCart && typeof yoclayApplySyncedMontagemToPayload === 'function') {
      prepared = yoclayApplySyncedMontagemToPayload(cartPayload, syncedCart);
    } else {
      prepared = yoclayMutateCartPayloadForYampi(cartPayload);
    }
    prepared = yoclayMergeYampiCheckoutPayloadOverride(prepared);
    if (typeof window.yoclayApplyPackPricingForYampi === 'function') {
      prepared = window.yoclayApplyPackPricingForYampi(prepared);
    }
    return prepared;
  }

  window.yoclayWhenFigmaReady = yoclayWhenFigmaReady;
  window.yoclayPrepareYampiCartPayload = yoclayPrepareYampiCartPayload;

  function yoclayBeforeYampiCartPushPromise() {
    return yoclayWhenFigmaReady().then(function () {
      if (typeof window.yoclaySyncPocketMontagemToCart !== 'function') return null;
      return window.yoclaySyncPocketMontagemToCart().then(function (cart) {
        if (cart) {
          try {
            window.__yoclayLastSyncedCart = cart;
          } catch (e) {
            /* ignore */
          }
        }
        return cart;
      });
    });
  }

  function yoclayDelay(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, typeof ms === 'number' ? ms : 0);
    });
  }

  window.yoclayDelay = yoclayDelay;

  window.yoclayBeforeYampiCartPushPromise = yoclayBeforeYampiCartPushPromise;

  function yoclayBuildMontagemFromCart(cart) {
    if (!cart || !cart.items || !cart.items.length) {
      return { noteBlock: '', attrValue: '', attrFull: '', lines: [] };
    }

    var lines = [];
    cart.items.forEach(function (item) {
      var pockets = yoclayGetPocketsFromLineItem(item);
      if (!pockets) return;
      var qty = item.quantity > 1 ? ' (x' + item.quantity + ')' : '';
      lines.push(
        'Montagem ' + yoclayShortKitTitle(item.product_title, yoclayExtractLineItemHandle(item)) + qty + ': ' + pockets
      );
    });

    if (!lines.length) {
      return { noteBlock: '', attrValue: '', attrFull: '', lines: [] };
    }

    var attrValue = lines.join(' | ');
    var attrFull = lines.join('\n');
    var noteBlock = yoclayBuildMontagemNoteBlock(attrValue);
    return { noteBlock: noteBlock, attrValue: attrValue, attrFull: attrFull, lines: lines };
  }

  function yoclayBuildMontagemNoteBlock(attrValue) {
    if (!attrValue) return '';
    return YOCLAY_MONTAGEM_NOTE_POCKETS + ' ' + attrValue;
  }

  function yoclayStripMontagemFromNote(note) {
    if (!note || typeof note !== 'string') return '';
    var markers = [
      YOCLAY_MONTAGEM_NOTE_HEADER_LEGACY,
      YOCLAY_MONTAGEM_NOTE_POCKETS,
      YOCLAY_MONTAGEM_NOTE_KITS
    ];
    var cutIdx = -1;
    var i;
    for (i = 0; i < markers.length; i++) {
      var idx = note.indexOf(markers[i]);
      if (idx !== -1 && (cutIdx === -1 || idx < cutIdx)) cutIdx = idx;
    }
    if (cutIdx === -1) return note.trim();
    return note.slice(0, cutIdx).trim();
  }

  function yoclayMergeCartNote(existingNote, montagemBlock) {
    var customerNote = yoclayStripMontagemFromNote(existingNote || '');
    if (!montagemBlock) return customerNote;
    if (!customerNote) return montagemBlock;
    // Montagem primeiro: ERPs (Bling) costumam priorizar o início de order.note
    return montagemBlock + '\n\n' + customerNote;
  }

  function yoclayClearLegacyMontagemAttrs(target) {
    YOCLAY_MONTAGEM_LEGACY_ATTR_KEYS.forEach(function (key) {
      target[key] = '';
    });
  }

  function yoclayApplyMontagemAttrsToMap(target, montagem) {
    yoclayClearLegacyMontagemAttrs(target);
    if (!montagem || !montagem.lines.length) {
      target[YOCLAY_MONTAGEM_ATTR_POCKETS_UPPER] = '';
      target[YOCLAY_MONTAGEM_ATTR_KITS_UPPER] = '';
      return;
    }
    target[YOCLAY_MONTAGEM_ATTR_POCKETS_UPPER] = montagem.attrValue;
    target[YOCLAY_MONTAGEM_ATTR_KITS_UPPER] = montagem.attrFull;
  }

  /** Garante note/attributes no cart_payload enviado à Yampi (evita race após sync). */
  function yoclayApplySyncedMontagemToPayload(cartPayload, syncedCart) {
    if (!cartPayload || !syncedCart) return cartPayload;
    var montagem = yoclayBuildMontagemFromCart(syncedCart);
    var next = Object.assign({}, cartPayload);
    next.attributes = Object.assign({}, cartPayload.attributes || {}, syncedCart.attributes || {});
    yoclayClearLegacyMontagemAttrs(next.attributes);
    if (montagem.lines.length) {
      next.note = yoclayMergeCartNote(syncedCart.note || cartPayload.note, montagem.noteBlock);
      yoclayApplyMontagemAttrsToMap(next.attributes, montagem);
    } else {
      yoclayApplyMontagemAttrsToMap(next.attributes, montagem);
    }
    return yoclayMutateCartPayloadForYampi(next);
  }

  window.yoclayApplySyncedMontagemToPayload = yoclayApplySyncedMontagemToPayload;

  function yoclayMontagemPayloadNeedsUpdate(cart, nextNote, nextAttrs) {
    if ((cart.note || '') !== nextNote) return true;
    var current = cart.attributes || {};
    var keys = Object.keys(nextAttrs).concat(YOCLAY_MONTAGEM_LEGACY_ATTR_KEYS);
    var seen = {};
    return keys.some(function (key) {
      if (seen[key]) return false;
      seen[key] = true;
      return (current[key] || '') !== (nextAttrs[key] || '');
    });
  }

  function syncPocketLineDisplayPropertiesToCart(cart) {
    if (!cart || !cart.items || !cart.items.length) return Promise.resolve(cart);

    var updates = [];
    cart.items.forEach(function (item) {
      if (!item || !item.key) return;
      var pockets = yoclayGetPocketsFromLineItem(item);
      if (!pockets || !yoclayIsKitLineItem(item)) return;
      var displayTitle = yoclayClampLineDisplayTitle(
        yoclayGetLineDisplayTitleFromProperties(item) ||
          yoclayBuildKitLineDisplayName(item.product_title, pockets, yoclayExtractLineItemHandle(item))
      );
      if (!displayTitle || yoclayLineDisplayPropertiesComplete(item.properties, pockets, displayTitle)) {
        return;
      }
      updates.push(
        fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            id: item.key,
            quantity: item.quantity,
            properties: Object.assign(
              {},
              yoclayLinePropertiesToMap(item.properties),
              yoclayBuildLineDisplayPropertiesMap(pockets, displayTitle)
            )
          })
        })
      );
    });

    if (!updates.length) return Promise.resolve(cart);

    return Promise.all(updates)
      .then(function () {
        return fetch('/cart.js', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });
      })
      .then(function (response) {
        if (!response.ok) throw new Error('cart.js failed');
        return response.json();
      })
      .catch(function () {
        return cart;
      });
  }

  function syncPocketMontagemToCart() {
    if (yoclayMontagemSyncInFlight) return yoclayMontagemSyncInFlight;

    yoclayMontagemSyncInFlight = fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart.js failed');
        return response.json();
      })
      .then(function (cart) {
        var montagem = yoclayBuildMontagemFromCart(cart);
        var nextNote = yoclayMergeCartNote(cart.note, montagem.noteBlock);
        var nextAttrs = {};

        yoclayApplyMontagemAttrsToMap(nextAttrs, montagem);

        if (!yoclayMontagemPayloadNeedsUpdate(cart, nextNote, nextAttrs)) {
          return syncPocketLineDisplayPropertiesToCart(cart);
        }

        yoclayClearLegacyMontagemAttrs(nextAttrs);

        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            note: nextNote,
            attributes: nextAttrs
          })
        }).then(function (response) {
          if (!response.ok) throw new Error('cart/update.js failed');
          return response.json();
        });
      })
      .then(function (cart) {
        if (!cart) return null;
        return syncPocketLineDisplayPropertiesToCart(cart);
      })
      .catch(function () {
        return null;
      })
      .then(function (result) {
        yoclayMontagemSyncInFlight = null;
        if (result) {
          try {
            window.__yoclayLastSyncedCart = result;
          } catch (e) {
            /* ignore */
          }
        }
        return result;
      });

    return yoclayMontagemSyncInFlight;
  }

  function schedulePocketMontagemSync(delayMs) {
    if (yoclayMontagemSyncTimer) window.clearTimeout(yoclayMontagemSyncTimer);
    yoclayMontagemSyncTimer = window.setTimeout(function () {
      yoclayMontagemSyncTimer = null;
      syncPocketMontagemToCart();
    }, typeof delayMs === 'number' ? delayMs : 120);
  }

  window.yoclaySyncPocketMontagemToCart = syncPocketMontagemToCart;

  // Intercept fetch/XHR to react when the legacy add-to-cart flow finishes.
  function interceptCartRequests() {
    if (window.yoclayCartInterceptReady) return;
    window.yoclayCartInterceptReady = true;

    function looksLikeAdd(url) {
      return typeof url === 'string' && /\/cart\/add(\.js)?(\?|$)/.test(url);
    }
    function looksLikeChange(url) {
      return typeof url === 'string' && /\/cart\/(change|update)(\.js)?(\?|$)/.test(url);
    }

    if (typeof window.fetch === 'function') {
      var originalFetch = window.fetch.bind(window);
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var promise = originalFetch(input, init);

        if (looksLikeAdd(url)) {
          promise.then(function (response) {
            if (!response.ok) return;
            // Defer so theme.js callbacks finish first
            window.setTimeout(function () {
              refreshCartCountFromCart()
                .then(function () {
                  return syncPocketMontagemToCart();
                })
                .then(function () {
                  bumpCartCount();
                  return refreshCartDrawer();
                })
                .then(openCartDrawer);
            }, 80);
          }, function () {});
        } else if (looksLikeChange(url)) {
          promise.then(function (response) {
            if (!response.ok) return;
            window.setTimeout(function () {
              refreshCartCountFromCart()
                .then(function () {
                  return syncPocketMontagemToCart();
                })
                .then(refreshCartDrawer);
            }, 40);
          }, function () {});
        }

        return promise;
      };
    }

    if (window.XMLHttpRequest) {
      var XHR = window.XMLHttpRequest.prototype;
      var origOpen = XHR.open;
      var origSend = XHR.send;

      XHR.open = function (method, url) {
        this.__yoclayUrl = url;
        return origOpen.apply(this, arguments);
      };

      XHR.send = function () {
        var url = this.__yoclayUrl || '';
        var isAdd = looksLikeAdd(url);
        var isChange = looksLikeChange(url);
        if (isAdd || isChange) {
          this.addEventListener('load', function () {
            if (this.status < 200 || this.status >= 300) return;
            window.setTimeout(function () {
              refreshCartCountFromCart()
                .then(function () {
                  return syncPocketMontagemToCart();
                })
                .then(function () {
                  if (isAdd) bumpCartCount();
                  return refreshCartDrawer();
                })
                .then(function () {
                  if (isAdd) openCartDrawer();
                });
            }, isAdd ? 80 : 40);
          });
        }
        return origSend.apply(this, arguments);
      };
    }
  }

  function markScrollRevealTargets(scope) {
    var root = scope && scope.nodeType === 1 ? scope : document;
    var selectors = [
      '.yoclay-product-card:not([data-yoclay-scroll-reveal])',
      '.yoclay-category-card:not([data-yoclay-scroll-reveal])',
      '.yoclay-product-row .yoclay-section-heading:not([data-yoclay-scroll-reveal])',
      '.yoclay-category-showcase .yoclay-section-heading:not([data-yoclay-scroll-reveal])',
      '.yoclay-studio__header:not([data-yoclay-scroll-reveal])',
      '.yoclay-studio__item:not([data-yoclay-scroll-reveal])',
      '.yoclay-intent-chips .yoclay-chip:not([data-yoclay-scroll-reveal])',
      '.yoclay-coupon:not([data-yoclay-scroll-reveal])',
      '.yoclay-product-row .yoclay-carousel-shell:not([data-yoclay-scroll-reveal])'
    ];

    selectors.forEach(function (selector) {
      root.querySelectorAll(selector).forEach(function (el, index) {
        el.setAttribute('data-yoclay-scroll-reveal', 'pending');
        if (!el.hasAttribute('data-yoclay-reveal-delay')) {
          el.setAttribute('data-yoclay-reveal-delay', String((index % 6) * 60));
        }
      });
    });
  }

  function revealScrollTarget(el) {
    var delay = el.getAttribute('data-yoclay-reveal-delay');
    if (delay) {
      el.style.setProperty('--yoclay-reveal-delay', delay + 'ms');
    }
    el.setAttribute('data-yoclay-scroll-reveal', 'done');
  }

  function runScrollReveals(reduceMotion) {
    var pending = document.querySelectorAll('[data-yoclay-scroll-reveal="pending"]');
    if (!pending.length) return;

    if (reduceMotion) {
      pending.forEach(revealScrollTarget);
      return;
    }

    if (!window.yoclayScrollRevealObserver) {
      window.yoclayScrollRevealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            revealScrollTarget(entry.target);
            window.yoclayScrollRevealObserver.unobserve(entry.target);
          });
        },
        { root: null, rootMargin: '0px 0px -10% 0px', threshold: 0.08 }
      );
    }

    pending.forEach(function (el) {
      window.yoclayScrollRevealObserver.observe(el);
    });
  }

  function setupScrollReveals(scope) {
    markScrollRevealTargets(scope);
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    runScrollReveals(reduceMotion);
  }

  function pocketKitMessage(required, selected) {
    if (selected < required) {
      return (
        'Selecione mais ' +
        (required - selected) +
        ' pocket' +
        (required - selected === 1 ? '' : 's') +
        ' (total: ' +
        required +
        ').'
      );
    }
    if (selected > required) {
      return 'Remova ' + (selected - required) + ' pocket(s). O kit permite apenas ' + required + '.';
    }
    return '';
  }

  function setupPocketKitPicker(picker) {
    if (!picker || picker.dataset.yoclayPocketKitReady === 'true') return;
    picker.dataset.yoclayPocketKitReady = 'true';

    var required = parseInt(picker.getAttribute('data-required-count'), 10) || 0;
    if (!required) return;

    var form = picker.closest('form');
    var checkboxes = Array.prototype.slice.call(picker.querySelectorAll('[data-yoclay-pocket-checkbox]'));
    var propertyInput = picker.querySelector('[data-yoclay-pocket-property]');
    var errorEl = picker.querySelector('[data-yoclay-pocket-error]');
    var countEl = picker.querySelector('[data-yoclay-pocket-count]');
    var addBtn = form ? form.querySelector('[data-add-to-cart]') : null;

    function selectedCheckboxes() {
      return checkboxes.filter(function (cb) {
        return cb.checked;
      });
    }

    function selectedNames() {
      return selectedCheckboxes().map(function (cb) {
        return cb.value;
      });
    }

    function isValid() {
      return selectedCheckboxes().length === required;
    }

    function variantBlocksAdd() {
      if (!addBtn) return true;
      if (addBtn.disabled && addBtn.getAttribute('data-yoclay-pocket-blocked') !== 'true') {
        return true;
      }
      return false;
    }

    function showError(message) {
      if (!errorEl) return;
      if (!message) {
        errorEl.hidden = true;
        errorEl.textContent = '';
        picker.classList.remove('yoclay-pocket-kit--error');
        return;
      }
      errorEl.hidden = false;
      errorEl.textContent = message;
      picker.classList.add('yoclay-pocket-kit--error');
    }

    var propertyOrderNameInput = picker.querySelector('[data-yoclay-pocket-property-order-name]');

    function kitTitleForProperty() {
      var kitTitle = picker.getAttribute('data-kit-title') || '';
      if (form) {
        var titleEl = form.querySelector('[data-yoclay-product-title]');
        if (titleEl && titleEl.textContent) kitTitle = titleEl.textContent.trim();
      }
      return kitTitle || 'Kit';
    }

    function updateProperty() {
      var pockets = isValid() ? selectedNames().join(', ') : '';
      var orderLineName = pockets
        ? yoclayClampLineDisplayTitle(yoclayShortKitTitle(kitTitleForProperty()) + ' — ' + pockets)
        : '';
      if (propertyInput) propertyInput.value = pockets;
      if (propertyOrderNameInput) propertyOrderNameInput.value = orderLineName;
    }

    function updateCounter() {
      var count = selectedCheckboxes().length;
      if (countEl) countEl.textContent = String(count);
      picker.classList.toggle('yoclay-pocket-kit--complete', count === required);
    }

    function updateCheckboxLimits() {
      var count = selectedCheckboxes().length;
      var atMax = count >= required;
      checkboxes.forEach(function (cb) {
        if (!cb.checked && atMax) {
          cb.disabled = true;
          cb.closest('.yoclay-pocket-kit__option').classList.add('yoclay-pocket-kit__option--disabled');
        } else {
          cb.disabled = false;
          cb.closest('.yoclay-pocket-kit__option').classList.remove('yoclay-pocket-kit__option--disabled');
        }
      });
    }

    function syncAddToCart() {
      updateProperty();
      updateCounter();
      updateCheckboxLimits();

      var valid = isValid();
      var msg = pocketKitMessage(required, selectedCheckboxes().length);
      showError(valid ? '' : msg);

      if (!addBtn || variantBlocksAdd()) return;

      if (valid) {
        addBtn.disabled = false;
        addBtn.removeAttribute('data-yoclay-pocket-blocked');
        addBtn.removeAttribute('aria-describedby');
      } else {
        addBtn.disabled = true;
        addBtn.setAttribute('data-yoclay-pocket-blocked', 'true');
        if (errorEl && errorEl.id) {
          addBtn.setAttribute('aria-describedby', errorEl.id);
        }
      }
    }

    checkboxes.forEach(function (cb) {
      cb.addEventListener('change', syncAddToCart);
    });

    if (form) {
      form.addEventListener(
        'submit',
        function (evt) {
          syncAddToCart();
          if (isValid()) return;
          evt.preventDefault();
          evt.stopImmediatePropagation();
          var message =
            'Escolha exatamente ' +
            required +
            ' pockets para continuar. ' +
            pocketKitMessage(required, selectedCheckboxes().length);
          showError(message);
          if (typeof window.theme !== 'undefined' && typeof window.theme.showQuickPopup === 'function' && addBtn) {
            window.theme.showQuickPopup(message, window.jQuery ? window.jQuery(addBtn) : addBtn);
          }
          var firstUnchecked = checkboxes.find(function (box) {
            return !box.disabled && !box.checked;
          });
          if (firstUnchecked) firstUnchecked.focus();
        },
        true
      );
    }

    syncAddToCart();
    setTimeout(syncAddToCart, 0);
    setTimeout(syncAddToCart, 400);
  }

  function setupPocketKitPickers(scope) {
    var root = scope && scope.nodeType === 1 ? scope : document;
    root.querySelectorAll('[data-yoclay-pocket-kit-picker]').forEach(setupPocketKitPicker);
  }

  if (!window.yoclayPocketKitVariantListenerReady) {
    window.yoclayPocketKitVariantListenerReady = true;
    document.addEventListener('on:variant:change', function (evt) {
      var form = evt.detail && evt.detail.form;
      if (!form) return;
      var picker = form.querySelector('[data-yoclay-pocket-kit-picker]');
      if (picker && picker.dataset.yoclayPocketKitReady === 'true') {
        var checkboxes = picker.querySelectorAll('[data-yoclay-pocket-checkbox]:checked');
        var addBtn = form.querySelector('[data-add-to-cart]');
        var required = parseInt(picker.getAttribute('data-required-count'), 10) || 0;
        var variantOk = evt.detail.variant && evt.detail.variant.available;
        if (!addBtn) return;
        if (!variantOk) {
          addBtn.disabled = true;
          addBtn.removeAttribute('data-yoclay-pocket-blocked');
          return;
        }
        if (checkboxes.length === required) {
          addBtn.disabled = false;
          addBtn.removeAttribute('data-yoclay-pocket-blocked');
        } else {
          addBtn.disabled = true;
          addBtn.setAttribute('data-yoclay-pocket-blocked', 'true');
        }
      }
    });
  }

  // Public API
  window.yoclayCartDrawer = {
    open: openCartDrawer,
    close: closeCartDrawer,
    refresh: refreshCartDrawer
  };

  var YOCLAY_URGENCY_NAMES = [
    'Larissa', 'Marina', 'Camila', 'Beatriz', 'Fernanda', 'Juliana', 'Rafaela',
    'Carolina', 'Amanda', 'Gabriela', 'Isabela', 'Natália', 'Patrícia', 'Vanessa',
    'Priscila', 'Bianca', 'Letícia', 'Renata', 'Aline', 'Bruna', 'Helena', 'Luiza'
  ];

  var YOCLAY_URGENCY_CITIES = [
    'Rio de Janeiro', 'São Paulo', 'Belo Horizonte', 'Curitiba', 'Brasília',
    'Porto Alegre', 'Salvador', 'Recife', 'Fortaleza', 'Florianópolis',
    'Campinas', 'Goiânia', 'Manaus', 'Vitória'
  ];

  var YOCLAY_URGENCY_PRODUCTS_FALLBACK = [
    'Kit Presentear', 'Trio Exploradores', 'Kit Salva Tédio', 'Pocket Ursito'
  ];

  function hashString(str) {
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
      hash = ((hash << 5) - hash) + str.charCodeAt(i);
      hash |= 0;
    }
    return Math.abs(hash);
  }

  function getYoclaySessionId() {
    var key = 'yoclay-urgency-session';
    try {
      var id = sessionStorage.getItem(key);
      if (!id) {
        id = String(Date.now()) + '-' + String(Math.floor(Math.random() * 10000));
        sessionStorage.setItem(key, id);
      }
      return id;
    } catch (e) {
      return 'fallback';
    }
  }

  function clamp(n, min, max) {
    return Math.min(max, Math.max(min, n));
  }

  function setupUrgencyViewers(root) {
    var el = (root || document).querySelector('[data-yoclay-urgency-viewers]');
    if (!el || el.dataset.yoclayUrgencyViewersReady === 'true') return;
    el.dataset.yoclayUrgencyViewersReady = 'true';

    var handle = el.getAttribute('data-product-handle') || 'product';
    var boost = parseInt(el.getAttribute('data-viewer-boost'), 10) || 0;
    var countNode = el.querySelector('[data-yoclay-urgency-viewers-count]');
    if (!countNode) return;

    var storageKey = 'yoclay-viewers-' + handle;
    var count;

    try {
      var stored = sessionStorage.getItem(storageKey);
      if (stored) {
        count = parseInt(stored, 10);
      }
    } catch (e) {
      /* ignore */
    }

    if (!count || isNaN(count)) {
      var seed = hashString(handle + getYoclaySessionId());
      count = 8 + (seed % 11) + boost;
      count = clamp(count, 8, 24);
      try {
        sessionStorage.setItem(storageKey, String(count));
      } catch (e2) {
        /* ignore */
      }
    }

    function renderCount(value) {
      countNode.textContent = String(value);
      el.setAttribute('aria-label', value + ' pessoas estão vendo este produto agora');
    }

    renderCount(count);
  }

  function setupUrgencyToast() {
    var root = document.querySelector('[data-yoclay-urgency-toast]');
    if (!root || root.dataset.yoclayUrgencyToastReady === 'true') return;
    root.dataset.yoclayUrgencyToastReady = 'true';

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return;

    var path = (window.location.pathname || '').toLowerCase();
    if (path.indexOf('/cart') !== -1 || path.indexOf('/checkout') !== -1) return;

    try {
      if (sessionStorage.getItem('yoclay-urgency-toast-dismissed') === '1') return;
    } catch (e) {
      /* ignore */
    }

    var messageEl = root.querySelector('[data-yoclay-urgency-toast-message]');
    var closeBtn = root.querySelector('[data-yoclay-urgency-toast-close]');
    if (!messageEl) return;

    var pageProduct = (root.getAttribute('data-product-label') || '').trim();
    var productPool = [];
    try {
      var productsJson = root.getAttribute('data-yoclay-urgency-products');
      if (productsJson) {
        var parsed = JSON.parse(productsJson);
        if (Array.isArray(parsed)) {
          productPool = parsed.filter(function (item) {
            return typeof item === 'string' && item.trim().length > 0;
          });
        }
      }
    } catch (parseErr) {
      /* ignore */
    }
    if (!productPool.length) {
      productPool = YOCLAY_URGENCY_PRODUCTS_FALLBACK.slice();
    }
    if (pageProduct) {
      productPool = [pageProduct].concat(productPool.filter(function (label) {
        return label !== pageProduct;
      }));
    }

    var lastPairKey = '';
    var hideTimer = null;
    var cycleTimer = null;
    var visible = false;

    function randomItem(arr) {
      return arr[Math.floor(Math.random() * arr.length)];
    }

    function buildMessage() {
      var name;
      var city;
      var pairKey;
      var attempts = 0;
      do {
        name = randomItem(YOCLAY_URGENCY_NAMES);
        city = randomItem(YOCLAY_URGENCY_CITIES);
        pairKey = name + '|' + city;
        attempts += 1;
      } while (pairKey === lastPairKey && attempts < 12);
      lastPairKey = pairKey;

      var productLabel = randomItem(productPool);
      var productLower = productLabel.toLowerCase();
      var productPhrase;
      if (productLower.indexOf('kit') === 0 || productLower.indexOf('trio') === 0 || productLower.indexOf('super kit') === 0) {
        productPhrase = 'o ' + productLabel;
      } else if (productLower.indexOf('pocket') !== -1) {
        productPhrase = 'um ' + productLabel;
      } else if (productLower.indexOf('box') === 0) {
        productPhrase = 'a ' + productLabel;
      } else {
        productPhrase = 'o ' + productLabel;
      }

      return name + ' de ' + city + ' acabou de comprar ' + productPhrase + ' 🔥';
    }

    function hideToast(callback) {
      if (!visible) {
        if (callback) callback();
        return;
      }
      root.classList.remove('yoclay-urgency-toast--visible');
      root.classList.add('yoclay-urgency-toast--leaving');
      window.clearTimeout(hideTimer);
      hideTimer = window.setTimeout(function () {
        root.classList.remove('yoclay-urgency-toast--leaving');
        root.hidden = true;
        visible = false;
        if (callback) callback();
      }, reduceMotion ? 0 : 320);
    }

    function showToast() {
      messageEl.textContent = buildMessage();
      root.hidden = false;
      root.classList.add('yoclay-urgency-toast--visible');
      visible = true;
      window.clearTimeout(hideTimer);
      hideTimer = window.setTimeout(function () {
        hideToast();
      }, 5200);
    }

    function scheduleNext(delay) {
      window.clearTimeout(cycleTimer);
      var wait = delay != null
        ? delay
        : 10000 + Math.floor(Math.random() * 10001);
      cycleTimer = window.setTimeout(function () {
        if (document.hidden) {
          scheduleNext(4000);
          return;
        }
        if (visible) {
          hideToast(function () {
            window.setTimeout(showToast, 400);
            scheduleNext();
          });
        } else {
          showToast();
          scheduleNext();
        }
      }, wait);
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        window.clearTimeout(cycleTimer);
        window.clearTimeout(hideTimer);
        hideToast();
        root.hidden = true;
        try {
          sessionStorage.setItem('yoclay-urgency-toast-dismissed', '1');
        } catch (e2) {
          /* ignore */
        }
      });
    }

    scheduleNext(4500 + Math.floor(Math.random() * 3500));
  }

  document.addEventListener('DOMContentLoaded', function () {
    setupScrollReveals(document);
    document.querySelectorAll('[data-yoclay-hero-carousel]').forEach(setupHeroCarousel);
    document.querySelectorAll('.yoclay-carousel-shell').forEach(setupCarousel);
    document.querySelectorAll('[data-yoclay-tabs]').forEach(function (tabs) {
      var section = tabs.closest('.yoclay-section');
      if (section) setupTabs(section);
    });
    setupMobileSubmenus(document);
    setupMobileDrawer(document);
    setupProductMenuAccordions(document);
    setupStickyHeader();
    document.querySelectorAll('[data-yoclay-instagram]').forEach(setupInstagramFeed);
    setupCartDrawer();
    interceptCartRequests();
    setupPocketKitPickers(document);
    if (document.body && document.body.classList.contains('template-cart')) {
      schedulePocketMontagemSync(200);
    }
    setupUrgencyViewers(document);
    setupUrgencyToast();
  });

  document.addEventListener('shopify:section:load', function (event) {
    setupScrollReveals(event.target);
    event.target.querySelectorAll('[data-yoclay-hero-carousel]').forEach(setupHeroCarousel);
    event.target.querySelectorAll('.yoclay-carousel-shell').forEach(setupCarousel);
    event.target.querySelectorAll('[data-yoclay-tabs]').forEach(function (tabs) {
      var section = tabs.closest('.yoclay-section');
      if (section) setupTabs(section);
    });
    setupMobileSubmenus(event.target);
    setupMobileDrawer(event.target);
    setupProductMenuAccordions(event.target);
    setupStickyHeader();
    event.target.querySelectorAll('[data-yoclay-instagram]').forEach(setupInstagramFeed);
    setupCartDrawer();
    setupPocketKitPickers(event.target);
    setupUrgencyViewers(event.target);
  });
})();
